/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Login_Verify_Email_MessageInputs */

const en_login_verify_email_message = /** @type {(inputs: Login_Verify_Email_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We've sent a verification link to <strong>${i?.email}</strong>. Please check your email and click the verification link to continue.`)
};

const fr_login_verify_email_message = /** @type {(inputs: Login_Verify_Email_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nous avons envoyé un lien de vérification à <strong>${i?.email}</strong>. Veuillez vérifier votre email et cliquer sur le lien de vérification pour continuer.`)
};

const de_login_verify_email_message = /** @type {(inputs: Login_Verify_Email_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wir haben einen Bestätigungslink an <strong>${i?.email}</strong> gesendet. Bitte überprüfen Sie Ihre E-Mails und klicken Sie auf den Bestätigungslink, um fortzufahren.`)
};

const it_login_verify_email_message = /** @type {(inputs: Login_Verify_Email_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abbiamo inviato un link di verifica a <strong>${i?.email}</strong>. Controlla la tua email e clicca sul link di verifica per continuare.`)
};

const ru_login_verify_email_message = /** @type {(inputs: Login_Verify_Email_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Мы отправили ссылку для подтверждения на адрес <strong>${i?.email}</strong>. Пожалуйста, проверьте свою электронную почту и перейдите по ссылке для подтверждения, чтобы продолжить.`)
};

const es_login_verify_email_message = /** @type {(inputs: Login_Verify_Email_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hemos enviado un enlace de verificación a <strong>${i?.email}</strong>. Revisa tu correo electrónico y haz clic en el enlace para continuar.`)
};

const zh_cn2_login_verify_email_message = /** @type {(inputs: Login_Verify_Email_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我们已向<strong>${i?.email}</strong>发送验证链接。请查收您的电子邮件并点击验证链接以继续。`)
};

const ja_login_verify_email_message = /** @type {(inputs: Login_Verify_Email_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<strong>${i?.email}</strong> さんに確認リンクを送信しました。メールをご確認の上、確認リンクをクリックして続行してください。`)
};

const hi_login_verify_email_message = /** @type {(inputs: Login_Verify_Email_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`हमने <strong>${i?.email}</strong> पर एक सत्यापन लिंक भेजा है। कृपया अपना ईमेल देखें और आगे बढ़ने के लिए सत्यापन लिंक पर क्लिक करें।`)
};

const pt_pt2_login_verify_email_message = /** @type {(inputs: Login_Verify_Email_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviamos um link de verificação para <strong>${i?.email}</strong>. Por favor, verifique seu e-mail e clique no link de verificação para continuar.`)
};

/**
* | output |
* | --- |
* | "We've sent a verification link to <strong>{email}</strong>. Please check your email and click the verification link to continue." |
*
* @param {Login_Verify_Email_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_verify_email_message = /** @type {((inputs: Login_Verify_Email_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Verify_Email_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_verify_email_message(inputs)
	if (locale === "de") return de_login_verify_email_message(inputs)
	if (locale === "it") return it_login_verify_email_message(inputs)
	if (locale === "ru") return ru_login_verify_email_message(inputs)
	if (locale === "es") return es_login_verify_email_message(inputs)
	if (locale === "zh-CN") return zh_cn2_login_verify_email_message(inputs)
	if (locale === "ja") return ja_login_verify_email_message(inputs)
	if (locale === "hi") return hi_login_verify_email_message(inputs)
	if (locale === "pt-PT") return pt_pt2_login_verify_email_message(inputs)
	return en_login_verify_email_message(inputs)
});